import React from 'react';
import styles from './style.module.css';

export function CustomGrid({ children }) {
  return <div className={styles.grid}>{children}</div>;
}

export function CustomGridItem({ xs = 12, sm, md, children }) {
  const classNames = [styles.item, styles[`col-${xs}`]];

  if (sm) classNames.push(styles[`col-sm-${sm}`]);
  if (md) classNames.push(styles[`col-md-${md}`]);

  return <div className={classNames.join(' ')}>{children}</div>;
}
